import { useGetMagazinesQuery } from '@/hooks/magazine/mobile/magazine.gql.impl';
import { parseMagazineHomeNewest } from '@/parsers/Communication/magazine';

const useGetFaqs = () => {
  const { data: faqs, isLoading: faqsIsLoading } = useGetMagazinesQuery(
    {
      magazineCursorPageRequestInput: {
        size: 5,
        contentType: 'FAQ',
      },
    },
    {
      select: (data) =>
        parseMagazineHomeNewest(data.magazineCursorPage.elements),
    },
  );

  return {
    faqs: faqs ?? [],
    faqsIsLoading,
  };
};

export default useGetFaqs;
